import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopeOpenRegularTemplate from './envelope-open-regular-template-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <EnvelopeOpenRegularTemplate {...props} />;
}
SvgComponent.iconName = 'envelopeOpenRegularTemplate';

export const EnvelopeOpenRegularTemplateIcon = svgIconWrapper(SvgComponent);
